import { render, staticRenderFns } from "./PendingConfirmed.vue?vue&type=template&id=52b31fb6"
import script from "./PendingConfirmed.vue?vue&type=script&lang=js"
export * from "./PendingConfirmed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports